import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, Subscription} from 'rxjs';
import {Chart} from 'chart.js';

@Component({
  selector: 'app-bar-chart-questionnaires-total',
  templateUrl: './bar-chart-questionnaires-total.component.html',
  styleUrls: ['./bar-chart-questionnaires-total.component.css']
})
export class BarChartQuestionnairesTotalComponent implements OnInit, OnDestroy {

  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  isHovered = false;
  subscription1: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  dataSource;
  canvas: any;
  ctx: any;
  myChartQuestionnaires: Chart;
  // ******************************************************************************************************************
  // seguenti righe: inizializzazione dei questionari
  //
  // ******************************************************************************************************************
  nums: number[] = [];
  // ******************************************************************************************************************
  // bar chart dei questionari
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['CLINICAL-HBI','CLINICAL-SCCAI','IBDQ','MMAS8','MIAH-CD','HBI','MIAH-UC','PATIENT-SCCAI','LARS'];
  public barChartTypeGlobal = 'bar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.nums, label: 'Numero questionari', backgroundColor: ['teal', 'teal','teal','teal','teal','teal', 'teal','teal','teal','teal'],
      hoverBackgroundColor: ['#066', '#066'], barThickness: 60,  // number (pixels) or 'flex'
    }
  ];

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private snackBar: MatSnackBar) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription3 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata();
      this.retrieveQuestionnairesTotal();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
  }

  retrievedata() {
    this.subscription1 = this.doctorService.getQuestionnairesStats().subscribe( data => {
      console.log(data);
      this.parseData(data);
      this.canvasSetting();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  parseData(data){
    for (let element in Object.keys(data)){
      var label = this.barChartLabelsGlobal[element];
      //console.log("Element: " + label);
      //console.log("Data[element]: " + data[label]);
      var p = data[label];
      var array = p.split("-",2);
      //console.log("Array " + label + " : " + array[0] + " " + array[1]);
      this.nums[element] = parseInt(array[0]);
      }
    console.log("Numbers of questionnaires: " + this.nums);
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartQuestionnaires') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartQuestionnaires = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        scales: {
          xAxes: [{
            display: true,
            stacked: false,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: false,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero totale di questionari',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    retrieveQuestionnairesTotal(){
      this.subscription4 = this.doctorService.getQuestionnairesTotal().subscribe( total => {
        console.log("Total questionnaires: " + total);
      });
      this.subscription5 = this.doctorService.getQuestionnairesTotalFemale().subscribe(total_female => {
        console.log("Total questionnaires female: " + total_female);
      })
    }

}
